const swea = require('swea');
const ViewerManager = swea.editor.ViewerManager;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;

class CustomLoadModelCommand extends swea.editor.loadcommands.LoadModelCommand {
  /**
   * Creates a custom load model command.
   * @param { object } options An option object, see LoadModelCommand.
   * @public
   * @overridden
   */
  constructor(options = {}) {
    options.implicitSelect = (options.implicitSelect !== undefined ? options.implicitSelect : true);
    super(options);
  }

  /**
   * Called to execute the command, adding text as instruction and setting wait cursor.
   * @override
   * @public
   */
  do(resolve) {
    InstructionServiceActions.showInstruction('instructions.loading_model');
    ViewerManager.instance().getViewerById(this.getViewerId()).setCursor('wait');
    return super.do(() => {
      ViewerManager.instance().getViewerById(this.getViewerId()).setCursor(this._options.multiple ? 'crosshair' : 'default');
      InstructionServiceActions.hideInstruction();
      resolve();
    });
  }
}

swea.react.services.EditorStateService.addLoadableCommand(CustomLoadModelCommand);

export default CustomLoadModelCommand;
